import { createExtensionTemplateReader } from '@next-adapter/extension-template-reader.js'

export const integrationTemplates = createExtensionTemplateReader('integrations')
